function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "patio_heater"
}, /*#__PURE__*/React.createElement("title", null, "190808_VF_Nina_App_Icons_RZ"), /*#__PURE__*/React.createElement("path", {
  d: "M205.6 0H77.9C46.6 0 21.2 25.4 21.2 56.8v28.4h76.7c.3 20.7 11.7 36 29.7 41.1v72.1h-7.1c-15.6 0-28.3 12.7-28.3 28.4v56.7h99.1v-56.7c0-15.7-12.7-28.4-28.3-28.4h-7.1v-72.1c18-5.2 29.4-20.4 29.7-41.1h76.7V56.8c0-31.4-25.4-56.8-56.7-56.8zM163 226.7v28.4h-42.5v-28.4H163zm-21.3-127c-14.4 0-15.3-9.8-15.4-14.5h30.8c0 4.7-1 14.5-15.4 14.5zM49.5 56.8c0-15.7 12.7-28.4 28.3-28.4h128.7c15.6 0 28.3 12.7 28.3 28.4H49.5z"
}))));